import * as actions from '../actions/actionTypes';

export const initialState = {
  trialContainers: {},
  trialContainerAllIds: [],
  trialContainerRequest: {
    fetchRequest: {
      error: {},
      loading: false,
    },
  },
};
// eslint-disable-next-line
export default function (state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_TRIAL_CONTAINERS_SUCCESS: {
      const trialContainersMap = new Map();
      action.trialContainers.forEach((trialContainer) => {
        trialContainersMap.set(trialContainer.id, trialContainer);
      });

      return { ...state, trialContainers: Object.fromEntries(trialContainersMap) };
    }
    case actions.FETCH_TRIAL_CONTAINERS_FAILURE: {
      const trialContainerRequestErrorCopy = {
        fetchRequest: {
          ...state.trialContainerRequest.fetchRequest,
          error: action.error,
        },
      };

      return { ...state, trialContainerRequest: trialContainerRequestErrorCopy };
    }
    case actions.SET_TRIAL_CONTAINER_FETCH_REQUEST_LOADING: {
      const trialContainerRequestLoadingCopy = {
        fetchRequest: {
          ...state.trialContainerRequest.fetchRequest,
          loading: action.loading,
        },
      };

      return { ...state, trialContainerRequest: trialContainerRequestLoadingCopy };
    }
    case actions.SET_TRIAL_CONTAINER_ALL_IDS:
      return { ...state, trialContainerAllIds: action.trialContainerIds };

    default:
      return state;
  }
}
